
var $catFilter,
    $catFilterClose,
    $catFilterOpen,
    $catToggle,
    $wooFilter,
    $wooFilterClose,
    $wooFilterOpen,

    $wooGallery,
    $wooGalleryMenu,
    $wooNumberInput,

    $wooSearchForm,
    $wooSearchInput,
    $wooSearchAndFilterSearchField,

    $wooTogglePasswordVisibility,
    $wooCouponFormButton,
    $wooCouponFormButtonCheckout,

    $stickyCart,
    $stickyCartAnchor,

    $productPrices,
    $quantityContainer,

    $addressSelect,

    $orderForm,
    $shippingForm,
    $checkoutAddress,
    $target;



$(document).ready(function($) {
  var $body = $('body');

  // Filter vars
  $catFilter           = $('.js-cat-filter');
  $catFilterClose      = $('.js-cat-filter-close');
  $catFilterOpen       = $('.js-cat-filter-open');
  $wooFilter           = $('.js-woo-filter');
  $wooFilterClose      = $('.js-woo-filter-close');
  $wooFilterOpen       = $('.js-woo-filter-open');
  $catToggle           = $('.js-cat-open');

  // Product gallery vars
  $wooGallery          = $('.js-woo-gallery');
  $wooGalleryMenu      = $('.js-product-slider-menu');
  $wooNumberInput      = $('.js-woo-number-input');

  // Product archive vars
  $wooSearchForm                  = $('.js-search-form');
  $wooSearchInput                 = $('.js-search-input');
  $wooSearchAndFilterSearchField  = $('.sf-field-search');

  // Input vars
  $wooTogglePasswordVisibility    = $('.js-toggle-password-visibility');

  // Coupon vars (shopping cart)
  $wooCouponFormButton         = $('.js-coupon-button');
  $wooCouponFormButtonCheckout = $('.js-checkout-coupon button');


  $stickyCart        = $('.js-sticky-cart');
  $stickyCartAnchor = $('.js-sticky-cart-anchor');

  $productPrices       = $('.c-product-info__prices');
  $quantityContainer   = $('.c-add-to-cart');

  // Address select
  $addressSelect = $('.js-address-select');

  // Checkout Address seperate fields
  $orderForm = $('.js-billing-form');
  $shippingForm = $('.js-sending-form');
  $checkoutAddress = $('.js-checkout-address');


  // Filter events
  $catFilterOpen.on('click', function(e){
    $catFilter.addClass('is-open');
    $body.addClass('has-open-filter');
  });

  $catFilterClose.on('click', function(e){
    $catFilter.removeClass('is-open');
    $wooFilter.removeClass('is-open');
    $body.removeClass('has-open-filter');
  });

  $wooFilterOpen.on('click', function(e){
    $wooFilter.addClass('is-open');
    $body.addClass('has-open-filter');
  });

  $wooFilterClose.on('click', function(e){
    $wooFilter.removeClass('is-open');
    $body.removeClass('has-open-filter');
  });

  $catToggle.on('click', function(e){
    var $thisRef = $(this);

    if ($thisRef.hasClass('is-open')) {
      $thisRef.next().slideUp();
      $thisRef.removeClass('is-open');
    } else {
      $catToggle.next().slideUp();
      $thisRef.next().slideDown();
      $thisRef.addClass('is-open');
    }
  });

  $addressSelect.on('change', function(e) {
    var shop_id = $(this).val();
    var $shop = $('.js-shop-' + shop_id);

    if (!$shop.length > 0) {
      return;
    }

    // Show correct info
    $('.js-shop').removeClass('is-active');
    $shop.addClass('is-active');

    // Retrieve data from selected shop
    var shop_json = $shop.data('json');

    // Update shop id

    $('#shop_id').val(shop_json.shop_id);

    // Prefill form with new data
    updateBillingInfo(shop_json);
    updateShippingInfo(shop_json);

  });

  function updateBillingInfo(shop_json) {
    var billing = shop_json.billingAddress;
    var oldCountry = $('#billing_country').val();

    $('#billing_first_name').val(shop_json.first_name);
    $('#billing_last_name').val(shop_json.last_name);
    $('#billing_company').val(billing.company);
    $('#billing_country').val(billing.country);
    $('#billing_address_1').val(billing.street);
    $('#billing_postcode').val(billing.postal);
    $('#billing_city').val(billing.city);
    $('#billing_phone').val(billing.phone);
    $('#billing_email').val(billing.email);

    // Trigger checkout update if country changed to update shipping methods
    if (oldCountry !== billing.country) {
      $body.trigger('update_checkout');
    }
  }

  function updateShippingInfo(shop_json) {
    var shipping = shop_json.shippingAddress;
    var oldCountry = $('#shipping_country').val();

    $('#shipping_first_name').val(shop_json.first_name);
    $('#shipping_last_name').val(shop_json.last_name);
    $('#shipping_company').val(shipping.company);
    $('#shipping_country').val(shipping.country);
    $('#shipping_address_1').val(shipping.street);
    $('#shipping_postcode').val(shipping.postal);
    $('#shipping_city').val(shipping.city);
    $('#shipping_phone').val(shipping.phone);
    $('#shipping_email').val(shipping.email);

    // Trigger checkout update if country changed to update shipping methods
    if (oldCountry !== shipping.country) {
      $body.trigger('update_checkout');
    }
  }

  // Number input, updates the quantity value on the add-to-cart button
  $body.on('change keyup', '.js-woo-number-input', function() {
    var minValue = parseInt($(this).attr('min')) || 0;
    var maxValue = parseInt($(this).attr('max')) || 0;
    var value = parseInt($(this).val()) || 0;
    var tooLow = value < minValue;
    var tooHigh = maxValue > 0 && value > maxValue;

    $('.js-min-product-per-cart-notification')
      .toggleClass('c-product-info__min-product-per-cart--red', tooLow);
    $('.js-max-product-per-cart-notification')
      .toggleClass('c-product-info__max-product-per-cart--red', tooHigh);
    $('.js-add-to-cart-button-wrapper')
      .toggleClass('c-add-to-cart__button--disabled', tooLow || tooHigh);

    var addToCartButton = $(this).parent().find('.add_to_cart_button').first();
    addToCartButton.attr('data-quantity', value);

    changeAddToCartUrl(addToCartButton);
  });

  $body.on('blur change', '#billing_address_houseno, #shipping_address_houseno', function() {
    var wrapper = $(this).closest('.form-row');
    wrapper.removeClass('woocommerce-validated').removeClass('woocommerce-invalid');
    if( $.isNumeric( $(this).val() ) ) { // check if contains numbers
      wrapper.addClass('woocommerce-validated'); // success
    } else {
      wrapper.addClass('woocommerce-invalid'); // error
    }
  });

  $quantityContainer.find('input')
    .on('keyup', function (e) {
      if (e.keyCode === 13) {
        $(this).parent().find('.add_to_cart_button').click();
      }
    });

  if ($productPrices.find('span').length > 1 &&
    $productPrices.find('span').first()[0].innerText.trim() === $productPrices.find('span').last()[0].innerText.trim()) {
    $productPrices.find('span').last().remove();
  }

  // Gallery init
  if ($wooGallery.length > 0) {
    var $productSliderTarget = tns({
      container: '.js-woo-gallery',
      controls: false,
      autoplay: false,
      mode: 'gallery',
      navAsThumbnails: true,
      nav: false
    });

    // thumbnail menu
    $wooGalleryMenu.on('click', function(e) {
      e.stopPropagation();
      stopActiveProductVideo($('.js-product-slider-iframe'));
      var index = $(this).data('index');
      $productSliderTarget.goTo(index);
      $wooGalleryMenu.removeClass('is-active');
      $(this).addClass('is-active');
      var $activeSlide = $('.tns-slide-active');
      $activeSlide.find('.js-product-slider-iframe').first().addClass('is-active');
    });
  }

  // Product archive
  $wooSearchForm.submit(function(e) {
    e.preventDefault();

    var query = $wooSearchInput.val();
    $wooSearchAndFilterSearchField.find('input').val(query);
    $wooFilter.find('form').submit();

    hideBanners();
  });

  function hideBanners() {
    $(".js-banners").slideUp();
  }
  function showBanners() {
    $(".js-banners").slideDown();
  }

  $('.search-filter-reset').on('click', function(){
    showBanners();
  })

  $('.js-toggle-billing').on('click', function(e){
    e.preventDefault();
    $('.js-billing-form').slideToggle();
  });

  togglePasswordVisibility($wooTogglePasswordVisibility);

  // Update shopping cart on product amount change
  var time = 0;
  $body.on('change', '.js-update-cart input', function () {
    var value = $(this).val();
    var $target = $(this);

    var minValue = parseInt($target.attr('min')) || 0;
    var maxValue = parseInt($target.attr('max')) || 0;
    var $limits = $target.closest('.c-cart-item__update');

    $limits.find('.js-min-product-per-cart-notification')
      .toggleClass('c-product-info__min-product-per-cart--red', parseInt(value) < minValue);
    $limits.find('.js-max-product-per-cart-notification')
      .toggleClass('c-product-info__max-product-per-cart--red', maxValue > 0 && parseInt(value) > maxValue);

    var delay = 1500;
    // Reset the timer
    clearTimeout(time);

    time = setTimeout(function() {
      if (value < 1 || value.length === 0) {
        $target.val(1);
      }

      // Simulate click on the update cart button which is hidden.
      $("[name='update_cart']").trigger("click");
    }, delay);
  });

  // Coupon update input value
  $body.on('change keyup', '.js-add-coupon', function() {
    var value = $(this).val();
    $('#coupon_code').val(value);

    if (value.length > 0) {
      $('.js-submit-coupon').prop("disabled", false); // Element(s) are now enabled.
    } else {
      $('.js-submit-coupon').prop("disabled", true); // Element(s) are now disabled.
    }
  });

  // Submit in input with enter
  $body.on('keyup', '.js-add-coupon', function(e) {
    if (e.keyCode === 13) {
      $('.js-coupon-button').click();
      $('.js-checkout-coupon button').click();
    }
  });

  // Submit coupon
  $body.on('click', '.js-submit-coupon, .js-submit-coupon-checkout', function(e) {
    $('.js-coupon-button').click();
    $('.js-checkout-coupon button').click();
  });

  // Scroll event
  $(window).scroll(function() {
    toggleStickyCartHeader();
  });


  // Checkout address field
  if ( $orderForm.length > 0 || $shippingForm.length > 0 ) {

    function changeAddress(e) {
      $target = $(e.target);
      let targetParent = $target.parent().parent();
      let addressField = $(targetParent).parent().find('.js-checkout-address');
      
      if ( $(targetParent).hasClass('js-checkout-address-houseno') ) {
        let street = $(targetParent).parent().find('.js-checkout-address-street').find('input').val();
        let houseNoExtra = $(targetParent).parent().find('.js-checkout-address-houseno-extra').find('input').val();
        $(addressField).find('input').val(street + ' ' + $target.val() + ' ' + houseNoExtra); 
      }

      if ( $(targetParent).hasClass('js-checkout-address-street') ) {
        let houseNo = $(targetParent).parent().find('.js-checkout-address-houseno').find('input').val();
        let houseNoExtra = $(targetParent).parent().find('.js-checkout-address-houseno-extra').find('input').val();
        $(addressField).find('input').val($target.val() + ' ' + houseNo + ' ' + houseNoExtra); 
      }

      if ( $(targetParent).hasClass('js-checkout-address-houseno-extra') ) {
        let street = $(targetParent).parent().find('.js-checkout-address-street').find('input').val();
        let houseNo = $(targetParent).parent().find('.js-checkout-address-houseno').find('input').val();
        $(addressField).find('input').val(street + ' ' + houseNo + ' ' + $target.val()); 
      }

    }

    $body.on('change', function(e) {
      console.log(e);
      changeAddress(e)
    });
    $body.on('load', function() {
      changeAddress()
    });
  }

  // Show Belgium field always, but make it required only for Belgium (BE)
  function toggleBelgiumField(isCountryChange) {
    var $belgiumField = $('.js-belgium-field').closest('.form-row');
    var $btwInput = $('#billing_belgium_btw_no');
    var $label = $belgiumField.find('label');
    var selectedCountry = $('#billing_country').val();
    
    if (!$belgiumField.length) {
      return;
    }
    
    // Always show the field
    $belgiumField.removeClass('js-belgium-field-hidden');
    
    // Remove existing status text and asterisk
    $label.find('.field-status-text').remove();
    $label.find('abbr.required').remove();
    
    // Remove validation classes and error messages only when country changes
    if (isCountryChange) {
      $btwInput.removeClass('belgium-btw-valid belgium-btw-invalid');
      $belgiumField.removeClass('woocommerce-invalid woocommerce-validated');
      $('#billing_belgium_btw_no_field').removeClass('woocommerce-invalid woocommerce-validated');
      $belgiumField.find('.belgium-btw-validation-message').remove();
    }
    
    // Make required only for Belgium
    if (selectedCountry === 'BE') {
      $btwInput.prop('required', true);
      $btwInput.attr('pattern', '^[Bb][Ee]\\s?[0-9]{10}$');
      $belgiumField.addClass('validate-required');
      $belgiumField.removeClass('validate-optional');
      // Add required asterisk
      $label.append('<abbr class="required" title="verplicht">*</abbr>');
      // Add "(verplicht)" text
      $label.append('<span class="field-status-text"> (verplicht)</span>');
    } else {
      // All other countries: optional
      $btwInput.prop('required', false);
      $btwInput.removeAttr('pattern');
      $belgiumField.removeClass('validate-required');
      $belgiumField.addClass('validate-optional');
      // Remove validation classes and error message when not Belgium
      $btwInput.removeClass('belgium-btw-valid belgium-btw-invalid');
      $belgiumField.removeClass('woocommerce-validated woocommerce-invalid');
      $('#billing_belgium_btw_no_field').removeClass('woocommerce-validated woocommerce-invalid');
      $belgiumField.find('.belgium-btw-validation-message').remove();
      // Add "(optioneel)" text
      $label.append('<span class="field-status-text"> (optioneel)</span>');
    }
  }

  // Check on page load and when checkout updates
  function initBelgiumFieldToggle() {
    if ($('#billing_country').length > 0) {
      toggleBelgiumField(false);
      
      // Check on country change (using event delegation)
      $body.off('change', '#billing_country');
      $body.on('change', '#billing_country', function() {
        toggleBelgiumField(true);
        $body.trigger('update_checkout');
      });
      
      // Also listen for WooCommerce country update events
      $body.off('country_to_state_changing', function() {
        toggleBelgiumField(true);
      });
      $body.on('country_to_state_changing', function() {
        toggleBelgiumField(true);
      });
    }
    
    // Also handle shipping country changes
    if ($('#shipping_country').length > 0) {
      $body.off('change', '#shipping_country');
      $body.on('change', '#shipping_country', function() {
        $body.trigger('update_checkout');
      });
    }
  }

  // Initialize on page load
  initBelgiumFieldToggle();
  
  // Re-initialize after checkout updates (WooCommerce AJAX)
  $body.on('updated_checkout', function() {
    setTimeout(initBelgiumFieldToggle, 100);
  });
  
  // Trigger checkout update when Belgium BTW number field changes
  // This ensures taxes are recalculated when the BTW number is filled in
  // Also provides real-time validation feedback
  function initBelgiumBtwFieldUpdate() {
    var $btwField = $('#billing_belgium_btw_no');
    
    if ($btwField.length > 0) {
      // Remove existing listeners to prevent duplicates
      $body.off('input change blur', '#billing_belgium_btw_no');
      
      // Pattern for Belgium BTW number: BE (case-insensitive) followed by exactly 10 digits
      var btwPattern = /^[Bb][Ee]\s?[0-9]{10}$/;
      
      // Function to validate and show feedback
      function validateBtwNumber(value) {
        var $field = $('#billing_belgium_btw_no');
        var $formRow = $field.closest('.form-row');
        var $errorMessage = $formRow.find('.belgium-btw-validation-message');
        var selectedCountry = $('#billing_country').val();
        
        // Remove existing error message
        $errorMessage.remove();
        
        // Trim the value
        value = value.trim();
        
        // If empty, don't show validation (required validation will handle it)
        if (value === '') {
          $field.removeClass('belgium-btw-valid belgium-btw-invalid');
          $formRow.removeClass('woocommerce-validated woocommerce-invalid');
          return false;
        }
        
        // Only validate and show error message if Belgium is selected
        if (selectedCountry !== 'BE') {
          $field.removeClass('belgium-btw-valid belgium-btw-invalid');
          $formRow.removeClass('woocommerce-validated woocommerce-invalid');
          return true; // Consider valid for non-Belgium countries
        }
        
        // Check if valid
        var isValid = btwPattern.test(value);
        
        // Remove both classes first
        $formRow.removeClass('woocommerce-validated woocommerce-invalid');
        
        if (isValid) {
          // Valid: add success class and remove invalid class
          $field.removeClass('belgium-btw-invalid').addClass('belgium-btw-valid');
          $formRow.addClass('woocommerce-validated');
        } else {
          // Invalid: add error class and remove valid class
          $field.removeClass('belgium-btw-valid').addClass('belgium-btw-invalid');
          $formRow.addClass('woocommerce-invalid');
          
          // Show error message only for Belgium
          var errorText = 'Formaat: BE gevolgd door 10 cijfers (bijv. BE0123456789)';
          $errorMessage = $('<span class="belgium-btw-validation-message" style="display: block; color: #e2401c; font-size: 0.875em; margin-top: 0.5em;">' + errorText + '</span>');
          $formRow.append($errorMessage);
        }
        
        return isValid;
      }
      
      // Listen for input events (real-time validation while typing)
      $body.on('input', '#billing_belgium_btw_no', function() {
        var value = $(this).val();
        validateBtwNumber(value);
      });
      
      // Listen for change and blur events (validation + trigger checkout update)
      $body.on('change blur', '#billing_belgium_btw_no', function() {
        var value = $(this).val();
        var isValid = validateBtwNumber(value);
        
        // Only trigger checkout update if valid (to avoid unnecessary AJAX calls)
        if (isValid || value === '') {
          $body.trigger('update_checkout');
        }
      });
      
      // Validate on page load if field already has a value
      if ($btwField.val()) {
        validateBtwNumber($btwField.val());
      }
    }
  }
  
  // Initialize on page load
  initBelgiumBtwFieldUpdate();
  
  // Re-initialize after checkout updates (WooCommerce AJAX)
  $body.on('updated_checkout', function() {
    setTimeout(initBelgiumBtwFieldUpdate, 100);
  });
  
  
});

function stopActiveProductVideo($iframes) {
  $iframes.each(function() {
    if ($(this).hasClass('is-active')) {
      var src = $(this)[0].src;
      src = src.replace("?autoplay=1", "");
      $(this)[0].src = src;
      $(this).removeClass('is-active');
    }
  });
}

function togglePasswordVisibility(forElements) {
  forElements.each(function() {
    $(this).on('click', function() {
      var input = $(this).next('input')[0];

      if (input.type === "password") {
        input.type = "text";
      } else {
        input.type = "password";
      }
    });
  });
}


function toggleStickyCartHeader() {
  if ($stickyCartAnchor.length > 0) {
    if($stickyCartAnchor.isInViewport()){
      $stickyCart.removeClass('is-visible');
    } else {
      $stickyCart.addClass('is-visible');
    }
  }

}

$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};


function changeAddToCartUrl(element) {
  var quantity = element.attr('data-quantity');
  var id = element.attr('data-product_id');

  var newLink = '?add-to-cart=' + id + '&quantity=' + quantity;

  element.attr('href', newLink)
}
